// This file is code that is generated from Eloqua forms
// This function runs on the init hook when the page is loaded.
// If a new form is needed it can be created via https://hogwarts.genesys.com/kb/eloqua-external-form-builder.  However, this template creator doesn't address custom fields, or advanced options and configurations.  Contact Patrick Cruz about this.

/**
 * Load all the necessary form scripts.
 */
function addEloquaFormsScripts() {
  var _elqQ = _elqQ || [];
  _elqQ.push(['elqSetSiteId', '1260946616']);
  _elqQ.push(['elqUseFirstPartyCookie', 'tkelq.genesys.com']);
  _elqQ.push(['elqTrackPageView', window.location.href]);
  (function () {
    var s = document.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.src = '//img04.en25.com/i/elqCfg.min.js';
    var x = document.getElementsByTagName('script')[0];
    x.parentNode.insertBefore(s, x);
  })();
}

/**
 * This function runs on the request quote button click, but is also generated by Eloqua forms and runs onload on BeyondCX page.
 * @param {*} formType to check if its a subscription page form or BeyondCX form
 */
function loadEloquaForm(formType) {
  var params = {
    form_type: formType, // This is passed by the calling eloqua form component
    integration: 'beyondcart', // NOTE: This is needed to help Marketing Dev team tell traffic is coming from the Beyond UI Client
    cta_header: eloquaFormAttributes(formType).cta_header, // NOTE: Beyond Cart form type is used for Request Quote, but we don't have a Cart anymore.
    cta_button: eloquaFormAttributes(formType).cta_button,
    cid_id: eloquaFormAttributes(formType).cid_id, // NOTE: Form type ids are provided by Genesys Marketing Eloqua Team
    form_action: 'inline', // NOTE: formType page = redirects from page after submit, inline keesp the user on the current page after submit
    form_p_target: 'custom',
    ar_status: 'no',
    ar_title_dynamic: 'custom',
    ar_url_dynamic: 'custom',
  };
  var domain = 'https://www.genesys.com';
  var language = '';
  var pluginurl = '/_external-form';
  var queryParam = $.param(params);
  var requrl = domain + language + pluginurl + '?' + queryParam + ' #eloqua_embed';

  $('#eloqExternal').load(requrl, function (response, status, xhr) {
    if (status == 'error') {
      var msg = 'ERROR: ';
      $('#error').html(msg + xhr.status + ' ' + xhr.statusText);
    } else if (status == 'success') {
      $.ajax({
        url:
          'https://www.genesys.com/wp-content/plugins/genesys-hook-marketo/scripts/eloquaload.min.js?buster=' +
          Date.now(),
        dataType: 'script',
        cache: 1,
        error: function () {
          console.log('Eloqua Main Script Error.');
        },
        success: function (data) {
          $('#eloqExternal').show();
        },
      });
    }
    var form = document.getElementById('form19');
    if (form) {
      form.addEventListener(
        'eloqReady',
        function (e) {
          var qs = location.search.replace('?', '');
          var pairs = qs.split('&');
          var items = {};
          for (var i = 0; i < pairs.length; i++) {
            items[pairs[i].split('=')[0]] = pairs[i].split('=')[1];
          }
          $.each(items, function (index, value) {
            $('[name="' + index + '"]').val(value);
          });
          $('#fe204').val(window.location);
        },
        false
      );
      form.addEventListener('eloqError', function (e) {}, false);
      form.addEventListener(
        'eloqSuccess',
        function (e) {
          // This will only trigger for BeyondCX form page and when the Request Consultation form is submitted successfully.
          if (formType == 'beyondcx') {
            // Show the thank you modal popup after submit.
            // User has to click the "x" to close this modal
            $('#eloqSuccessModal').show();
          }
          if (formType == 'beyondcart' || formType == '') {
            // Hide the submited modal form popup
            $('#requestQuote').hide();
            // Show the thank you modal popup after submit.
            // User has to click the "x" to close this modal
            $('#eloqSuccessQuoteModal').show();
          }
        },
        false
      );
    }
  });
}

/**
 * Eloqua form object used based on formType
 * @param {*} formType to check if its a subscription page form or BeyondCX form
 * @returns eloquaform object
 */
function eloquaFormAttributes(formType) {
  switch (formType) {
    case 'beyondcart':
      return { cta_header: 'Request Quote', cid_id: '7011T000001t7IUQAY', cta_button: 'Submit' }; // used for Subscription Detail
    case 'beyondcx':
      return { cta_header: '', cid_id: '7011T000001Yb0FQAS', cta_button: 'Submit' }; // used in Beyond CX
    default:
      return { cta_header: '', cid_id: '7011T000001t7IUQAY', cta_button: 'Contact Sales' }; // Form type will be empty and hence works in default case. Currently used in Home page Contact Sales
  }
}
